import { useAuth0 } from '@auth0/auth0-react';
import {useQuery} from 'react-query';
import useFetch from 'Api/useFetch';

export const useUserMetadata = () => {
    const { user } = useAuth0();

    return user?.['https://app.growing-people.nl/user_metadata'] ?? {};
}